import Cookies from "./cookies";

export default Cookies;
